import React from 'react';

const RssFeedPage = (props) => (
	<div className="container main">
		<h2>RSS Feed</h2>
		<div className="row">
			<div className="col-sm-12">
				<p>Would you like to receive notifications about the latest recalls posted on the OECD <i>Global portal on product recalls</i>?</p>
				<p>
					<a className={'rss-feed-link'} href={props.config.api + '/rss.xqy'}>Subscribe to our RSS feed.</a>
				</p>
				<p>You can also subscribe to our feed in a number of other ways, including following:</p>
				<ul className={'rss-feed-options'}>
					<li>Copy the URL of the RSS feed into your news reader.</li>
					<li>Copy the URL of the RSS feed into your browser.</li>
				</ul>
			</div>
		</div>
	</div>
);

export default RssFeedPage;



// WEBPACK FOOTER //
// ./src/views/static/en/rss-feed.js